import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  return (
    <div className="product-card">
      <Link to={`/product/${product._id}`}>
        <div className="product-image">
          <img 
            src={product.images && product.images[0] ? product.images[0] : '/placeholder.jpg'} 
            alt={product.name} 
          />
        </div>
        <div className="product-info">
          <h3>{product.name}</h3>
          <p className="product-category">
            {product.category?.name || 'Furniture'}
          </p>
          {product.stock === 0 && (
            <span className="out-of-stock">Out of Stock</span>
          )}
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
